// extracted by mini-css-extract-plugin
module.exports = {"postComment":"post-comment-count-module--post-comment--3M7B1"};